module.exports = __webpack_public_path__ + "img/5.c7cee865.png";